import { useEffect, useState } from 'react';

const useTimer = (
  timerDuration = 5,
  isAutoStart = true,
  onTimerEnd?: () => void,
  multiplier: number | undefined = 1
): {
  timer: number;
  resetTimer: () => void;
  activateTimer: () => void;
  stopTimer: () => void;
  isActive: boolean;
} => {
  const [timer, setTimer] = useState(timerDuration);
  const [isActive, setIsActive] = useState(isAutoStart);
  const resetTimer = (): void => {
    setTimer(timerDuration);
  };
  const activateTimer = (): void => {
    setIsActive(true);
  };
  const stopTimer = (): void => {
    setIsActive(false);
  };

  useEffect(() => {
    let interval: ReturnType<typeof setTimeout> | null = null;
    if (isActive) {
      interval = setTimeout(() => {
        if (onTimerEnd && timer <= 0) {
          onTimerEnd();
        }
        if (timer > 0) {
          setTimer(timer - 1 / (multiplier || 1));
        } else {
          if (interval) {
            clearTimeout(interval);
          }
        }
      }, 1000 / (multiplier || 1));
    }
    return () => {
      if (interval) {
        clearTimeout(interval);
      }
    };
  }, [isActive, multiplier, onTimerEnd, timer]);
  return { timer, resetTimer, activateTimer, stopTimer, isActive };
};

export default useTimer;
